export const runInTeliaRumService = <T>(service: string, func: () => T): T => {
  if (window.TeliaRum) {
    return window.TeliaRum.runInService(service, func);
  } else {
    return func();
  }
};
